<template>
  <div class="course-detail-page">
    <div class="course-header">
      <div class="course-info" v-if="course.id">
        <h1>{{ course.name }}</h1>
        <div class="time-level-bar">
          <div class="closeintime">
            <span class="close-text" v-if="!isClosed">
              Closes in
            </span>
            <span class="time" v-if="!isClosed">
              {{ countdown }}
            </span>
            <span class="time" v-else>
              Enrollment Closed
            </span>
          </div>
          <div class="level-text">
            <div class="levels">
              <div class="level-1"></div>
              <div class="level-2"></div>
              <div class="level-3"></div>
            </div>
            <div class="course-level">
              <h4>{{ course.level }}</h4>
              <div>Course</div>
            </div>
          </div>
        </div>
        <div class="course-initial">
          <div>
            
            <p>{{ course.description }}</p>
          </div>
          <div class="course-image">
            <img :src="course.course_image" alt="Course Image" />
          </div>
        </div>
        <div class="price">
          <h2 v-if="course.payment_option != 'free'">{{ course.price }} Azadi Coin (AC)</h2>
          <h2 v-else>FREE</h2>
          <span v-if="course.payment_option != 'free'" class="price-label">Price</span>
          <span v-else class="price-label"></span>
          <router-link v-if="course.payment_option != 'free' && !isClosed" :to="'/checkout/'+$route.params.id"><button class="enroll-btn">Enroll Now</button></router-link>
          <router-link v-if="course.payment_option == 'free' && !isClosed" :to="'/free-course/'+$route.params.id"
            ><button class="enroll-btn">Start Now</button></router-link
          >
        </div>
        <div class="course-details">
          <div>
            <div class="table-head">{{ course.duration }} minutes</div>
            <span>Duration</span>
          </div>
          <div>
            <div class="table-head">{{ course.certification }}</div>
            <span>Certification Validity</span>
          </div>
          <div>
            <div class="table-head">{{ course.exam_type }}</div>
            <span>Exam</span>
          </div>
          <div>
            <div class="table-head">{{ course.access_mode }}</div>
            <span>Access Mode</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      isClosed: false,
      futureDate: null,
      countdown: '',
      intervalId: null,
      oneHourBefore: null,
      activeModule: null,
      course: {},
    };
  },
  mounted() {
    this.getCourseDetails();
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    calculateOneHourBefore() {
      this.oneHourBefore = new Date(this.futureDate.getTime() - 60 * 60 * 1000);
    },
    startCountdown() {
      this.updateCountdown();
      this.intervalId = setInterval(() => {
        this.updateCountdown();
      }, 1000);
    },
    updateCountdown() {
      const now = new Date();
      const diff = this.oneHourBefore - now;
      if (diff > 0) {
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        this.countdown = `${days} Days | ${hours} hrs | ${minutes} mins | ${seconds} secs`;
      } else {
        this.countdown = "Enrollment Closed";
        this.isClosed = true;
        clearInterval(this.intervalId);
      }
    },
    toggleModule(index) {
      this.activeModule = this.activeModule === index ? null : index;
    },
    async getCourseDetails() {
      try {
        const response = await axios.get("training/view/"+this.$route.params.id);
        this.course = response.data.data;
        this.futureDate = new Date(this.course.date + " " + this.course.time);
        this.calculateOneHourBefore();
        this.startCountdown();
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style scoped>
.course-detail-page {
  text-align: center;
  font-family: 'GothicB';
}

.closeintime, .level-text {
  display: flex;
  gap: 1rem;
  align-items: center;
}
.time-level-bar {
  background-color: #F1B97D;
  margin: 2rem 0;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  color: #000;
}

.levels {
  display: flex;
  gap: 3px;
}
.levels div {
  width: 16px;
  height: 10px;
  border: 1px solid #F29430;
  background-color: #fff;
}

.levels div.level-1 {
  background-color: #F29430;
  border-radius: 6px 0 0 6px;
}

.levels div.level-3 {
  border-radius: 0 6px 6px 0;
}

.time {
  color: #000;
  font-size: 1.4rem;
  font-weight: 800;
}

.course-level {
  text-transform: capitalize;
}

.close-text, .course-level div {
  font-size: 0.8rem;
  color: #000;
}

.course-initial {
  display: flex;
  gap: 2rem;
}

.course-header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 3rem 2rem;
  max-width: 60rem;
  margin: 0 auto;
}

.course-info {
  text-align: left;
  flex: 1;
}

.course-info h1 {
  font-size: 2rem;
}

.course-info p {
  margin: 1rem 0;
  font-size: 0.95rem;
  color: #fff;
  font-family: 'Gothic';
}

.price {
  margin: 1.5rem 0;
}

.enroll-btn {
  padding: 0.6rem 2rem;
  background-color: #f0c57a;
  color: #000;
  border: 1px solid #f0ba7c;
  outline: none;
  border-radius: 0.5rem;
  font-weight: 700;
  font-size: 1rem;
  padding: 0.6rem 2rem;
  font-family: 'Gothic';
}

.enroll-btn:hover {
  background-color: #e0b56a;
}

.course-details {
  display: flex;
  gap: 1.5rem;
  margin: 2rem 0 0;
  flex-wrap: wrap;
  border: 1px solid #ccc;
  padding: 0.5rem 1rem;
  border-radius: 0.4rem;
}

.course-details > div {
  text-align: left;
  padding: 1rem 0;
  flex: 1;
}

.course-details > div:not(:last-child) {
  border-right: 1px solid #ccc;
  padding-right: 1rem;
}

.course-image img {
  max-width: 350px;
  border-radius: 10px;
}

.price-label {
  opacity: 0.5;
  font-size: 0.8rem;
  display: block;
  margin-bottom: 1.5rem;
}

.table-head {
  font-size: 1rem;
  display: block;
  margin-bottom: 0.5rem;
  font-family: 'Gothic';
  text-transform: capitalize;
}

.price h2 {
    color: #f0c57a;
}


</style>
